import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";

const AboutDeveloper = () => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="developer">
      {/* <div className="d-block pt-2 pb-1 text-center">
        <img
          src="images/birla-estates-logo.png"
          width="150px"
          height="70px"
          loading="lazy"
          alt="logo"
        />
      </div> */}
      <div className="row">
        <div className="col-md-8">
          <h2 className="d-block section-heading-sub text-capitalize">
            About Developer
          </h2>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetGradient effectScale download_brochure float-lg-right d-none d-lg-block"
            onClick={() => handleShowModal("AboutDev ChatWithUs")}
          >
            Chat with us
          </button>
        </div>
      </div>

      <p>
        Birla Estates is the real estate arm of Century Textiles and Industries
        Limited, a flagship company of the globally trusted Aditya Birla Group.
        With a deep-rooted legacy in innovation, transparency, and quality,
        Birla Estates has rapidly emerged as one of India's most reliable and
        design-forward developers. Their portfolio features landmark residential
        and commercial developments across India's top cities, seamlessly
        blending architectural excellence with functional design. By carrying
        forward the 100+ year legacy of the Aditya Birla Group, Birla Estates is
        redefining the future of urban living through master-planned communities
        and lifestyle-rich environments.
        <br />
        Every project by Birla Estates is a reflection of their commitment to
        sustainable development, customer-centric values, and intelligent space
        planning. Their developments not only focus on superior construction and
        premium finishes, but also create ecosystems that enhance everyday life
        — from green landscapes to well-integrated social infrastructure. With a
        vision to become the most admired real estate brand in India, Birla
        Estates continues to deliver projects that are future-ready, rooted in
        trust, and designed for modern lifestyles.
      </p>
      <div className="rera-numbers montserrat-font-400-85em">
        <div className="rera-item ">
          <img src="rearaBirla.jpeg" alt="Birla Estates Kalwa Thane" />
          <span>PR1331012502243</span>
        </div>
      </div>
      <p className="centerpara">
        <small className="montserrat-font">
          The project is registered with MahaRERA and details are available on
          the official MahaRERA website under registered projects.
        </small>
      </p>
      <button
        className="btn btn-info micro-form-btn enqModal effetGradient effectScale download_brochure float-lg-right mx-sm-auto d-lg-none"
        data-form="lg"
        data-title=" Chat with us"
        data-btn=" Chat with us"
        data-enquiry="Download Brochure Left Panel"
        data-redirect="enquiry"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={() => handleShowModal("AboutDev ChatWithUs")}
      >
        Chat with us
      </button>
    </section>
  );
};

export default AboutDeveloper;
